import { useState, useEffect } from "react";

export const useMobileOptimization = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Check if device is mobile
    const checkIsMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent
        );
      const isSmallScreen = window.innerWidth <= 768;
      setIsMobile(isMobileDevice || isSmallScreen);
    };

    // Check for reduced motion preference
    const checkReducedMotion = () => {
      setPrefersReducedMotion(
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      );
    };

    // Initial check
    checkIsMobile();
    checkReducedMotion();

    // Listen for resize events
    const handleResize = () => {
      checkIsMobile();
    };

    // Listen for motion preference changes
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handleMotionChange = (e) => {
      setPrefersReducedMotion(e.matches);
    };

    window.addEventListener("resize", handleResize);
    mediaQuery.addEventListener("change", handleMotionChange);

    return () => {
      window.removeEventListener("resize", handleResize);
      mediaQuery.removeEventListener("change", handleMotionChange);
    };
  }, []);

  // Get optimized animation class based on device and preferences
  const getAnimationClass = (baseClass) => {
    if (prefersReducedMotion) {
      return ""; // No animations for users who prefer reduced motion
    }

    // On mobile, use the same class but with CSS optimizations applied
    // The CSS will handle the mobile-specific optimizations
    return baseClass;
  };

  // Get optimized transition duration
  const getTransitionDuration = (baseDuration = "300") => {
    if (prefersReducedMotion) {
      return "0";
    }

    if (isMobile) {
      return Math.max(150, parseInt(baseDuration) * 0.5).toString(); // Reduce duration by 50% on mobile
    }

    return baseDuration;
  };

  return {
    isMobile,
    prefersReducedMotion,
    getAnimationClass,
    getTransitionDuration,
  };
};
